import React from 'react';
import type { SubKind } from 'reactApp/types/Tree';
import { Breadcrumbs } from 'reactApp/ui/Mobile/Breadcrumbs/Breadcrumbs';

import style from './MyTeamMobileEditorHeader.css';

type Props = {
    fileName: string;
    subKind: SubKind;
};
export const MyTeamMobileEditorHeader = ({ fileName, subKind }: Props) => {
    const handleClickBack = () => {
        if (document.referrer && document.referrer !== window.location.href) {
            window.location.href = `${document.referrer}?wv=1`;
        } else {
            window.location.href = '/home/?wv=1';
        }
    };

    return (
        <div className={style.wrapper}>
            <Breadcrumbs
                showBackButton
                name={subKind === 'text' ? 'Назад' : fileName}
                onClickBackButton={handleClickBack}
                backButtonIsArrow
            />
        </div>
    );
};
